import { AnimatePresence, motion } from "framer-motion";
import logo from "../img/logo.svg";

function Preloader({ visible }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.6, ease: "easeInOut" } }}
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#05193A]"
        >
          <motion.img
            src={logo}
            alt=""
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0, transition: { duration: 0.5 } }}
            className="w-[160px]"
          />
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { delay: 0.3, duration: 0.4 } }}
            className="mt-[36px] flex items-center gap-[10px]"
          >
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                className="block h-[8px] w-[8px] rounded-full bg-[#DAEBFC]"
                style={{ animation: `preloader-bounce 1.2s ease-in-out ${i * 0.18}s infinite` }}
              />
            ))}
          </motion.div>
          <style>{`
            @keyframes preloader-bounce {
              0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
              40% { transform: translateY(-10px); opacity: 1; }
            }
          `}</style>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default Preloader;
